import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const fetchComplaintDetails = async (departmentId = null) => {
  try {
    //  Call the function, not just reference it
    const url = API.complaint.getAll(departmentId);

    const response = await axiosInstance.get(url);

    if (!response.data) {
      throw new Error("Invalid API response structure");
    }

    return response.data;
  } catch (error) {
    console.error("Error fetching complaint details:", error);
    throw error;
  }
};

const fetchComplaintById = async (complaintId) => {
  try {
    const response = await axiosInstance.get(`${API.complaint.getById}/${complaintId}`);

    if (!response.data) {
      throw new Error("Invalid API response structure");
    }

    return response.data;
  } catch (error) {
    console.error(`Error fetching complaint ${complaintId}:`, error);
    throw error;
  }
};

const fetchAllDepartments = async () => {
  try {
    const response = await axiosInstance.get(API.department.getList);

    if (!response.data) {
      return [];
    }

    const departments = Array.isArray(response.data)
      ? response.data.map((dept) => ({
          id: dept.id,
          name: dept.name,
        }))
      : [];

    return departments;
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};

export { fetchComplaintDetails, fetchComplaintById, fetchAllDepartments };
